module.exports = __webpack_public_path__ + "media/music_42.2b035f67.mp3";